import { AbstractControl, FormGroup } from '@angular/forms';

export class AtLeastOneValidator {
	static atLeastOne(controlGroup: FormGroup) {
		let controls = controlGroup.controls;
		if (controls) {
			let theOne = Object.keys(controls).find(key => controls[key].value);
			if (!theOne) {
				return {
					atLeastOne: {
						text: 'Al menos un campo debe ser llenado'
					}
				};
			}
		}
		return null;
	}
}
